import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { isAdminAuthed } from "../lib/adminAuth";

/** Route guard for `/admin/*` pages — checks the admin session token independently of the
 *  CDP-based `RequireAuth`/`RequireRole` guards used everywhere else, since the admin dashboard
 *  is a wholly separate identity system (see apps/api/src/lib/adminAuth.ts). */
export function RequireAdminAuth({ children }: { children: ReactNode }) {
  if (!isAdminAuthed()) {
    return <Navigate to="/admin/login" replace />;
  }
  return <>{children}</>;
}
